import { render, staticRenderFns } from "./AddRecognition.vue?vue&type=template&id=474e0652&lang=pug&"
import script from "./AddRecognition.vue?vue&type=script&lang=js&"
export * from "./AddRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports